module.exports = __webpack_public_path__ + "img/GQ.2c34e86f.png";